import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  // Defensive: if useRoutes returns nothing, show a minimal fallback instead of blank
  if (!element) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50 text-foreground-900 px-6">
        <div className="text-center">
          <h1 className="font-heading text-xl mb-2">Loading...</h1>
          <p className="text-foreground-500 font-body text-sm">If this persists, please refresh the page.</p>
        </div>
      </div>
    );
  }

  return element;
}